var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-sidebar-arrow-wrapper cursor-pointer",class:{'collapsed': _vm.isMenuCollapsed},on:{"click":_vm.setMenuCollapsedToggle}},[_c('i',{class:_vm.arrowIcon})])
}
var staticRenderFns = []

export { render, staticRenderFns }